import * as Yup from 'yup';
import { StepIdentificatorForm } from './step-identificator-types';

export const stepIdentificatorSchema = () =>
  Yup.object<StepIdentificatorForm>().shape({
    type: Yup.string().nullable().required('Povinné pole'),
    subjectType: Yup.string().nullable().required('Povinné pole'),
    value: Yup.string().nullable().required('Povinné pole'),
  });
